import type { IExternalUser } from "@/interfaces/user";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export interface UserSliceI {
  users?: IExternalUser[];
}

const initialState: UserSliceI = {
  users: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserStateAction(state: UserSliceI, action: PayloadAction<UserSliceI>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetUser() {
      return initialState;
    },
  },
});

export default userSlice.reducer;
export const { setUserStateAction } = userSlice.actions;
